import { GroupPluginList } from "./GroupPluginList";

export default GroupPluginList;
